module.exports = __webpack_public_path__ + "img/Contact.96b96398.jpg";